<a [ngClass]="customCssClass" [routerLink]="route"><ng-content></ng-content></a>
